import React from 'react';
import { ReactElementLike } from 'prop-types';

interface SectionErrorBoundaryProps {
  name: string;
  message: string;
  children: ReactElementLike;
}
interface SectionErrorBoundaryState {
  hasError: boolean;
}

export default class SectionErrorBoundary extends React.Component<SectionErrorBoundaryProps, SectionErrorBoundaryState> {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(this.props.name, error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <section id="start-puffs" className="start-section">
          <div className="section-title-container">
            <h2 className="section-title">
              <span className="section-title-text">{this.props.message}</span>
            </h2>
          </div>
        </section>
      );
    }
    return this.props.children;
  }
}
